// angular
// .module("HeroPRO")
// .controller("KBYGModalController", kbygModalController);

import angular from 'angular';
import _ from 'lodash';
import './KBYGModal.scss';
import './addressBreakdown/KBYGAddressBreakdown.scss';
import './zipcodeCheck/KBYGZipcodeCheck.scss';

/* @ngInject */
export default function kbygModalController(KBYGFactory, UserData, raSpinnerService, $uibModalInstance, $analytics, ModalService, $document, UserAuthFactory, HPRoles, CommonDataFactory, $rootScope, $timeout, PermissionsFactory) {
    const vm = this;

    vm.kbygData = {};
    vm.kbygResponse = {};

    vm.organizations = [];
    // vm.originalOrganizations = [];
    vm.selectedOrganization = {};
    // vm.originalReps = [];
    vm.typeaheadReps = [];

    vm.selectedItem = '';
    vm.selectedSalesRep = { ContractorUserId: null }; // Adjusted from '' to prevent trying to read ContractorUserId off undefined object.
    vm.selectedLocation = {};
    vm.selectedCity = {};
    vm.selectedDirection = {};
    vm.selectedSuffix = '';
    vm.selectedState = {};
    vm.matchingAddress = null;
    vm.loadingText = 'Loading';
    vm.stateFilter = '';

    vm.selectedTypeaheadRep = '';
    vm.selectedOrg = '';

    vm.loading = true;
    vm.isMultipleAddresses = false;
    vm.isSmartyBreakdown = false;
    vm.isZipcodeLookup = false;
    vm.isZipCodeOutOfBounds = false;
    vm.hasResultsReturned = false;
    vm.isRaUser = false;
    vm.isEditingSalesRepLocation = false;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    vm.editSalesRepLocation = function editSalesRepLocation() {
        vm.isEditingSalesRepLocation = !vm.isEditingSalesRepLocation;
    };

    vm.closeKBYGModal = function closeKBYGModal() {
        raSpinnerService._unregister('kbygSpinner'); // eslint-disable-line no-underscore-dangle
        ModalService.closeLgModal();
    };

    $uibModalInstance.result.then(() => {
    }, () => {
        ModalService.closeLgModal();
        raSpinnerService._unregister('kbygSpinner'); // eslint-disable-line no-underscore-dangle
    });

    vm.clickNext = function clickNext() {
        vm.isZipcodeLookup = true;
    };

    vm.openZipcodeCheck = function openZipcodeCheck() {
        vm.isZipcodeLookup = true;
        if (!!vm.kbygData && !!vm.kbygData.smartyAddress) {
            vm.kbygData.smartyAddress.zipcode = '';
        }
    };

    vm.cancelZipcodeCheck = function cancelZipcodeCheck() {
        vm.isZipcodeLookup = false;
        $timeout(() => {
            $rootScope.$broadcast('triggerShowInvalidAddressDropDown');
        });
    };

    vm.getCompany = function getCompany(val) {
        const params = {
            Name: val,
            PageSize: 10,
            Operator: 2,
        };
        return KBYGFactory.getTypeaheadCompany(params).then((response) => {
            vm.organizations = response.data.Data;
            if (response.data.Data) {
                return response.data.Data.map(item => item.Name);
            }

            return [];
        });
    };

    vm.getSalesRep = function getSalesRep(val) {
        if (!vm.selectedOrganization || !vm.selectedOrganization.OrganizationId) {
            return [];
        }
        const params = {
            SalesRepName: val || '',
            OrgId: vm.selectedOrganization.OrganizationId,
            PageSize: 10,
        };
        return KBYGFactory.getTypeaheadSalesReps(params).then((response) => {
            vm.typeaheadReps = response.data.Data;
            if (response.data.Data) {
                return response.data.Data.map(item => item.FullName);
            }

            return [];
        });
    };

    // Clears previously selected Org and set Selected Org for Sales Rep typeahead
    vm.onCompanySelect = function onCompanySelect() {
        vm.selectedOrganization = _.find(vm.organizations, origOrg => origOrg.Name === vm.selectedOrg);
        vm.selectedTypeaheadRep = '';
    };

    // Sets Selected Sales Rep object to perform a lookup on Contractor User's available locations.
    vm.onSalesRepSelect = function onSalesRepSelect() {
        vm.selectedSalesRep = _.find(vm.typeaheadReps, origRep => origRep.FullName === vm.selectedTypeaheadRep);

        const payload = {
            ContractorUserId: vm.selectedSalesRep.ContractorUserId,
            OrganizationId: vm.selectedOrganization.OrganizationId,
        };
        KBYGFactory.getContractorLocations(payload).then((response) => {
            vm.locations = response.data.Data;
            vm.selectedLocation = vm.locations[0];
        });
    };

    vm.typeClicked = function typeClicked(item) {
        if (item !== undefined) {
            vm.selectedItem = item;
        }
        $analytics.eventTrack('Change Property Type', { category: 'KBYG' });
    };

    vm.salesRepClicked = function salesRepClicked(item) {
        if (item !== undefined) {
            vm.selectedSalesRep = item;
        }
        $analytics.eventTrack('Change Sales Rep', { category: 'KBYG' });
    };

    vm.cityClicked = function cityClicked(item) {
        if (item !== undefined) {
            vm.selectedCity = item;
        }
        vm.kbygData.smartyAddress.city = vm.selectedCity.Name;
    };

    vm.directionClicked = function directionClicked(item) {
        if (item !== undefined) {
            vm.selectedDirection = item;
        }
        vm.kbygData.smartyAddress.addressData.street_predirection = vm.selectedDirection.value;
    };

    vm.suffixClicked = function suffixClicked(item) {
        if (item !== undefined) {
            vm.selectedSuffix = item;
        }
        vm.kbygData.smartyAddress.addressData.street_suffix = vm.selectedSuffix;
    };

    vm.stateClicked = function stateClicked(item) {
        if (item !== undefined) {
            vm.selectedState = item;
        }
        vm.kbygData.smartyAddress.state = vm.selectedState.StateAbbreviation;
    };

    vm.kbygSpinnerLoaded = function kbygSpinnerLoaded() {
        raSpinnerService.show('kbygSpinner');
    };

    vm.selectMatchingAddress = function selectMatchingAddress(address) {
        vm.matchingAddress = {
            MatchingAddress: address,
        };
    };

    vm.processMatchingAddress = function processMatchingAddress() {
        vm.loadingText = 'Checking Address';
        vm.isMultipleAddresses = false;
        vm.submitKBYG(true);
    };

    function constructStreetAddress(addressData) {
        const number = (addressData.primary_number !== undefined && addressData.primary_number !== null && addressData.primary_number.trim() !== '') ? addressData.primary_number.toString() : '';
        const direction = (addressData.street_predirection !== undefined && addressData.street_predirection !== null && addressData.street_predirection.trim() !== '') ? `${addressData.street_predirection} ` : '';
        const name = (addressData.street_name !== undefined && addressData.street_name !== null && addressData.street_name.trim() !== '') ? addressData.street_name : '';
        const suffix = (addressData.street_suffix !== undefined && addressData.street_suffix !== null && addressData.street_suffix.trim() !== '' && addressData.street_suffix.trim() !== 'N/A') ? ` ${addressData.street_suffix}` : '';
        return {
            StreetNumber: number, StreetPrefix: direction, Street: name, StreetSuffix: suffix,
        };
    }

    function constructStreetAddressLine(addressData) {
        const number = (addressData.primary_number !== undefined && addressData.primary_number !== null) ? `${addressData.primary_number} ` : '';
        const predirection = (addressData.street_predirection !== undefined && addressData.street_predirection !== null) ? `${addressData.street_predirection} ` : '';
        const name = (addressData.street_name !== undefined && addressData.street_name !== null) ? addressData.street_name : '';
        const suffix = (addressData.street_suffix !== undefined && addressData.street_suffix !== null && addressData.street_suffix.trim() !== 'N/A') ? ` ${addressData.street_suffix}` : '';
        const postdirection = (addressData.street_postdirection !== undefined && addressData.street_postdirection !== null) ? ` ${addressData.street_postdirection}` : '';
        return number + predirection + name + suffix + postdirection;
    }

    // Function to create single line address
    function constructAddressLine(smartyAddress) {
        const unitDesignator = (vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined && vm.kbygData.smartyAddress.addressData.secondary_designator !== null) ? `${vm.kbygData.smartyAddress.addressData.secondary_designator} ` : '';
        const unitNumber = (vm.kbygData.smartyAddress.addressData.secondary_number !== undefined && vm.kbygData.smartyAddress.addressData.secondary_number !== null) ? vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '';
        const city = smartyAddress.city;
        const state = smartyAddress.state;
        const zip = smartyAddress.zipcode !== undefined ? smartyAddress.zipcode : '';
        return `${constructStreetAddressLine(smartyAddress.addressData)} ${unitDesignator}${unitNumber} ${city}, ${state} ${zip}`;
    }

    function getActiveStates() {
        CommonDataFactory.getStates(true).then((response) => {
            vm.stateFilter = _.pluck(response.data.Data, 'StateAbbreviation').join();
        });
    }

    function getLocations() {
        UserData.getKBYGLocations().then((response) => {
            // console.log("response",response.length,response);
            // var locations = _.where(response, {'ContractorStatusId': 2});
            // console.log("locations",locations.length,locations);
            vm.locations = response;
        });
    }

    function getSalesReps() {
        UserAuthFactory.getAuthorization().then((authResponse) => {
            const elevatedAccess = (authResponse.HasElevatedAccess !== undefined && authResponse.HasElevatedAccess !== null &&
                authResponse.HasElevatedAccess !== '') ? authResponse.HasElevatedAccess : false;
            const currentRole = _.find(HPRoles, (key, role) => role === authResponse.Roles[0]);
            vm.isRaUser = currentRole.Name === HPRoles.COPO_RAEMPLOYEE.Name;
            KBYGFactory.getSalesReps(vm.selectedLocation.ContractorId, !elevatedAccess).then((response) => {
                vm.salesReps = response.data.Data;

                if (!vm.isRaUser) {
                    const currentSalesRep = _.find(vm.salesReps, rep => rep.ContractorUserId === authResponse.ContractorUserId);

                    if (currentSalesRep !== undefined && currentSalesRep !== null) {
                        vm.selectedSalesRep = currentSalesRep;
                    } else {
                        vm.selectedSalesRep = vm.salesReps[0];
                    }
                }
                vm.loading = false;
            });
        });
    }

    vm.locationClicked = function locationClicked(item) {
        // Need to check for undefined since the native browser dropdowns used for small presentation
        // will not pass in an item when clicked but will set selectedLocation using ng-model instead.
        // The same is true for all kbyg modal dropdowns
        if (item !== undefined) {
            vm.selectedLocation = item;
        }
        $analytics.eventTrack('Change Location', { category: 'KBYG' });
        if (!vm.isRaUser) {
            getSalesReps();
        }
    };

    function getCurrentLocation() {
        UserData.getCurrentKBYGLocation().then((response) => {
            vm.selectedLocation = response;
            getSalesReps();
        });
    }

    vm.enterNewAddressClicked = function enterNewAddressClicked() {
        vm.kbygData = {};
        if (!vm.isRaUser) {
            getCurrentLocation();
        }
        vm.selectedItem = vm.propertyTypes[0];
        vm.hasResultsReturned = false;
        vm.kbygResponse.Address = undefined;
        vm.kbygResponse.isZipCodeOutOfBounds = false;
        vm.isSmartyBreakdown = false;
        vm.isMultipleAddresses = false;

        vm.matchingAddress = null;
    };

    function getPropertyTypes() {
        KBYGFactory.getPropertyType().then((response) => {
            vm.propertyTypes = response;
            vm.selectedItem = vm.propertyTypes[0];
        });
    }

    function getDirections() {
        KBYGFactory.getDirections().then((response) => {
            vm.directions = response;
            vm.selectedDirection = vm.directions[0];
            vm.kbygData.smartyAddress.addressData.street_predirection = vm.selectedDirection.value;
        });
    }

    function getStreetSuffixes() {
        KBYGFactory.getStreetSuffixes().then((response) => {
            vm.suffixes = response;
            vm.selectedSuffix = vm.suffixes[0];
            vm.kbygData.smartyAddress.addressData.street_suffix = vm.selectedSuffix;
        });
    }

    function getStatesForZipCode() {
        vm.states = [];
        _.each(vm.cities, (city) => {
            const state = _.find(vm.states, findState => findState.StateAbbreviation === city.StateGeo.StateAbbreviation);

            if (!state) {
                const stateName = city.StateGeo.Name.toLowerCase();
                city.StateGeo.Name = stateName.charAt(0).toUpperCase() + stateName.slice(1);
                vm.states.push(city.StateGeo);
            }
        });

        vm.selectedState = vm.states[0];
        vm.kbygData.smartyAddress.state = vm.selectedState.StateAbbreviation;
    }

    function setKbygResponse(payload, kbygResponse) {
        kbygResponse.Address = {
            Address1: payload.PropertyStreet1,
            City: payload.PropertyCity,
            State: payload.PropertyState,
            ZIPCode: payload.PropertyZip,
        };
        // Set Unit Number in KBYG Payload when an address is selected for Multiple Addresses.
        if (payload.MatchingAddress && payload.MatchingAddress.SITUS_UNIT_NUMBER) {
            kbygResponse.Address.Address2 = payload.MatchingAddress.SITUS_UNIT_NUMBER;
        } else {
            kbygResponse.Address.Address2 = payload.PropertyUnitNumber;
        }
        // if RA employee running for org, check for term sets
        if (!_.isEmpty(vm.selectedOrganization)) {
            kbygResponse.OrganizationId = vm.selectedOrganization.OrganizationId;
        }
        kbygResponse.Owner1FirstName = (kbygResponse.Owner1FirstName === undefined || kbygResponse.Owner1FirstName === null || kbygResponse.Owner1FirstName === '') ? payload.PropertyOwnerFirstName : kbygResponse.Owner1FirstName;
        kbygResponse.Owner1LastName = (kbygResponse.Owner1LastName === undefined || kbygResponse.Owner1LastName === null || kbygResponse.Owner1LastName === '') ? payload.PropertyOwnerLastName : kbygResponse.Owner1LastName;
        kbygResponse.AllOwner = (kbygResponse.AllOwner === undefined || kbygResponse.AllOwner === null || kbygResponse.AllOwner === '') ? null : kbygResponse.AllOwner;
        kbygResponse.ApprovedAmount = (kbygResponse.PreQualAmount === undefined || kbygResponse.PreQualAmount === '' || kbygResponse.PreQualAmount === null) ? payload.ApprovedAmount : kbygResponse.PreQualAmount;

        vm.kbygResponse = kbygResponse;
        vm.hasResultsReturned = true;
    }

    function performKBYGLookup(payload) {
        if (vm.matchingAddress !== null) {
            // We are performing a kbyg lookup as a result of a selection from a multiple result list
            payload.MatchingAddress = vm.matchingAddress.MatchingAddress;
        }

        KBYGFactory.submit(payload).then((response) => {
            const kbygResponse = response.data.Data;

            if (!_.isEmpty(kbygResponse) && kbygResponse.IsPropertyInBounds) {
                // Most common scenario. Green, Yellow or Red
                setKbygResponse(payload, kbygResponse);
                vm.isZipCodeOutOfBounds = false;
            } else if (!!kbygResponse.MatchingAddresses && kbygResponse.MatchingAddresses.length > 0) {
                // Multiple addresses were returned from the server
                vm.isMultipleAddresses = true;
                vm.hasResultsReturned = true;
                setKbygResponse(payload, kbygResponse);
            } else if (!kbygResponse.IsPropertyInBounds) {
                vm.kbygResponse.Address = {
                    Address1: payload.PropertyStreet1,
                    Address2: payload.PropertyUnitNumber,
                    City: payload.PropertyCity,
                    State: payload.PropertyState,
                    ZIPCode: payload.PropertyZip,
                };
                // Add Out of bounds result
                vm.kbygResponse.PreQualResult = 'OutOfBounds';
                //  vm.kbygResponse.IsPropertyInBounds = false;
                vm.hasResultsReturned = true;
                vm.isZipcodeLookup = false;
                vm.isZipCodeOutOfBounds = true;
            } else {
                // Add Undetermined result
                setKbygResponse(payload, {});
                // Force to Undetermined result when data is empty or null
                vm.kbygResponse.ApprovedAmount = 0;
                vm.kbygResponse.CreatedDate = new Date();
                vm.kbygResponse.PreQualResult = 'Undetermined';
            }
            vm.loading = false;
        }, () => {
            vm.closeKBYGModal();
        });
    }

    vm.submitKBYG = function submitKBYG(isValid) {
        if (isValid) {
            vm.loadingText = 'Checking Address';
            vm.loading = true;

            let payload = {};

            if (vm.isSmartyBreakdown === true) {
                payload = {
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    PropertyOwnerFirstName: vm.kbygData.poFirstName !== undefined ? vm.kbygData.poFirstName : '',
                    PropertyOwnerLastName: vm.kbygData.poLastName !== undefined ? vm.kbygData.poLastName : '',
                    PropertyStreet1: constructStreetAddressLine(vm.kbygData.smartyAddress.addressData),
                    PropertyStreetComposed: constructStreetAddress(vm.kbygData.smartyAddress.addressData),
                    PropertyUnitDesignator: (vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined &&
                        vm.kbygData.smartyAddress.addressData.secondary_designator !== null) ?
                        vm.kbygData.smartyAddress.addressData.secondary_designator : '',
                    PropertyUnitNumber: (vm.kbygData.smartyAddress.addressData.secondary_number !== undefined &&
                        vm.kbygData.smartyAddress.addressData.secondary_number !== null) ?
                        vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '',
                    PropertyCity: vm.kbygData.smartyAddress.city,
                    PropertyState: vm.kbygData.smartyAddress.state,
                    PropertyZip: vm.kbygData.smartyAddress.zipcode !== undefined ? vm.kbygData.smartyAddress.zipcode : '',
                    AddressRequiresValidation: true,
                    PropertyType: vm.selectedItem.id,
                };
                // Add analytics when KBYG is submitted from Breakdown
                $analytics.eventTrack('Individual Address Fields', { category: 'KBYG', label: constructAddressLine(vm.kbygData.smartyAddress) });
            } else {
                payload = {
                    ContractorLocationId: vm.selectedLocation.ContractorId,
                    ContractorUserId: vm.selectedSalesRep.ContractorUserId,
                    PropertyOwnerFirstName: vm.kbygData.poFirstName !== undefined ? vm.kbygData.poFirstName : '',
                    PropertyOwnerLastName: vm.kbygData.poLastName !== undefined ? vm.kbygData.poLastName : '',
                    PropertyStreet1: constructStreetAddressLine(vm.kbygData.smartyAddress.addressData),
                    PropertyUnitDesignator: (vm.kbygData.smartyAddress.addressData.secondary_designator !== undefined &&
                        vm.kbygData.smartyAddress.addressData.secondary_designator !== null) ?
                        vm.kbygData.smartyAddress.addressData.secondary_designator : '',
                    PropertyUnitNumber: (vm.kbygData.smartyAddress.addressData.secondary_number !== undefined &&
                        vm.kbygData.smartyAddress.addressData.secondary_number !== null) ?
                        vm.kbygData.smartyAddress.addressData.secondary_number.toString() : '',
                    PropertyCity: vm.kbygData.smartyAddress.city,
                    PropertyState: vm.kbygData.smartyAddress.state,
                    PropertyZip: vm.kbygData.smartyAddress.zipcode !== undefined ? vm.kbygData.smartyAddress.zipcode : '',
                    IsAddressVerified: vm.kbygData.smartyAddress.isValid,
                    AddressRequiresValidation: vm.kbygData.smartyAddress.dpvMatchCode === 'D',
                    PropertyType: vm.selectedItem.id,
                    PropertyStreetComposed: constructStreetAddress(vm.kbygData.smartyAddress.addressData),
                    PropertyProfileData: {
                        Apn: vm.kbygData.smartyAddress.addressData.apn,
                        FipsCode: vm.kbygData.smartyAddress.addressData.fips_code,
                    },
                };
            }
            $analytics.eventTrack('Submit KBYG', { category: 'KBYG' });
            performKBYGLookup(payload);
        } else {
            const invalidFields = angular.element($document[0].querySelectorAll('input.ng-invalid-required'));
            if (invalidFields.length > 0) {
                invalidFields[0].focus();
            }
        }
    };

    function performZipcodeLookup(data) {
        KBYGFactory.submitZipcode(data).then((response) => {
            if (response.data.Data === undefined || response.data.Data === null) {
                vm.kbygResponse.PreQualID = -1;
                vm.kbygResponse.PreQualResult = 'OutOfBounds';
                vm.kbygResponse.isZipCodeOutOfBounds = true;
                vm.hasResultsReturned = true;
                vm.isZipcodeLookup = false;
                // vm.isZipCodeOutOfBounds = true;
            } else {
                vm.cities = response.data.Data;
                vm.selectedCity = vm.cities[0];
                vm.kbygData.smartyAddress.city = vm.selectedCity.Name;
                vm.isSmartyBreakdown = true;
                vm.isZipcodeLookup = false;
                getDirections();
                getStreetSuffixes();
                getStatesForZipCode();
                vm.kbygData.smartyAddress.addressData = {};
                vm.kbygData.smartyAddress.addressText = '';
            }
            vm.loading = false;
        }, () => {
            vm.closeKBYGModal();
        });
    }

    vm.submitZipcode = function submitZipcode(isValid) {
        if (isValid) {
            vm.loadingText = 'Checking Address';
            vm.loading = true;
            performZipcodeLookup({
                ZipCode: vm.kbygData.smartyAddress.zipcode.toString(),
                IncludeWebsiteDetails: false,
            });
        }
    };

    function init() {
        vm.loading = true;
        getActiveStates();
        getCurrentLocation();
        getLocations();
        getPropertyTypes();
    }

    init();
}



// WEBPACK FOOTER //
// ./src/app/lead/kbyg/modal/KBYGModalController.js